import { createAction, props } from '@ngrx/store';

export const showBottomSheet = createAction('[Ui] Show Bottom Sheet');
export const showLegend = createAction('[Ui] Show Legend');
export const hideLegend = createAction('[Ui] Hide Legend');
export const hideBottomSheet = createAction('[Ui] Hide Bottom Sheet');
export const hideSidebar = createAction('[Ui] Hide Sidebar');
export const showSidebar = createAction('[Ui] Show Sidebar');
export const showMapSettings = createAction('[Ui] Show Map Settings');
export const hideMapSettings = createAction('[Ui] Hide Map Settings');
export const setNavbarState = createAction(
  '[Ui] Set Navbar State',
  props<{ state: boolean }>(),
);
